module.exports = __webpack_public_path__ + "img/jujiayanglaoshequfuwu_image_ylms.d05c01ee.png";